import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Pagination from './../../common/Pagination';
import numeral from 'numeral';
import moment from 'moment';
import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';

class Table extends Component {
    static propTypes = {
        elements: PropTypes.array,
        handleSort: PropTypes.func,
        handleUpdateFormValue: PropTypes.func,
        isFetchingElements: PropTypes.bool,
        handleShowForm: PropTypes.func,
        handleShowDelete: PropTypes.func,
        totalPages: PropTypes.number,
        selectedPage: PropTypes.number,
        elementsPerPage: PropTypes.number,
        sortColumn: PropTypes.string,
        sortType: PropTypes.string,
        handleOrdersClick: PropTypes.func,
        handleQuotesClick: PropTypes.func,
        handleChangeAttribute: PropTypes.func,
        handleInlineChange: PropTypes.func,
        handleDayChange: PropTypes.func,
        handleViewProperty: PropTypes.func,
        handleChangeFilter: PropTypes.func,
        processedElements: PropTypes.array
    };

    renderTableHeader(label, name, style, sortable = true) {
        const { handleSort, sortColumn, sortType } = this.props;

        let icon = <i className="fas fa-sort" />;
        if (sortColumn === name) {
            if (sortType === 'asc') {
                icon = <i className="fas fa-sort-up" />;
            } else {
                icon = <i className="fas fa-sort-down" />;
            }
        }

        if (sortable) {
            return <th style={style}><span onClick={handleSort.bind(this, name)}>{label} {icon}</span></th>;
        }

        return <th style={style}>{label}</th>;
    }

    renderData() {
        const { processedElements, isFetchingElements, handleShowForm, handleShowDelete, selectedPage, elementsPerPage,
            handleChangeAttribute, handleOrdersClick, handleQuotesClick } = this.props;

        if (isFetchingElements) {
            return (
                <tr>
                    <td colSpan="10"><i className="fas fa-circle-notch fa-spin" /> Loading data...</td>
                </tr>
            );
        }

        if (processedElements.length === 0) {
            return (
                <tr>
                    <td colSpan="10">No Results</td>
                </tr>
            );
        }

        let data = [];
        let startIndex = (selectedPage - 1) * elementsPerPage;
        for (let i = startIndex; i < processedElements.length && i < startIndex + elementsPerPage; i++) {
            data.push(
                <tr key={i}>
                    <td>{processedElements[i]['id']}</td>
                    <td>{processedElements[i]['company']}</td>
                    <td>{processedElements[i]['name']}</td>
                    <td>{processedElements[i]['email']}</td>
                    <td>{processedElements[i]['phone']}</td>
                    <td>{processedElements[i]['notes']}</td>
                    <td className="editable">
                        <select name="active" value={processedElements[i].active} onChange={(event) => handleChangeAttribute(i, 'active', 'text', event.target.value)}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </td>
                    <td>{processedElements[i]['last_quote_date'] ? moment(processedElements[i]['last_quote_date']).format('MM/DD/YYYY') : 'N/A'}</td>
                    <td>{numeral(processedElements[i]['total_quotes']).format('0,0')}</td>
                    <td>
                        <div className="actions">
                            <Tooltip title="Edit" position="bottom" arrow size="small" className="action-tooltip">
                                <i className="fas fa-edit" onClick={handleShowForm.bind(this, processedElements[i].id, null)} />
                            </Tooltip>
                            <Tooltip title="Orders" position="bottom" arrow size="small" className="action-tooltip hidden">
                                <i className="fas fa-shopping-cart" onClick={handleOrdersClick.bind(this, processedElements[i].id)} />
                            </Tooltip>
                            <Tooltip title="Quotes" position="bottom" arrow size="small" className="action-tooltip hidden">
                                <i className="fas fa-calculator" onClick={handleQuotesClick.bind(this, processedElements[i].id)} />
                            </Tooltip>
                            <Tooltip title="Delete" position="bottom" arrow size="small" className="action-tooltip">
                                <i className="fas fa-trash" onClick={handleShowDelete.bind(this, processedElements[i].id)} />
                            </Tooltip>
                        </div>
                    </td>
                </tr>
            );
        }

        return data;
    }

    renderSearchField(name) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <input type="text" name={name} className="search-input" onChange={handleChangeFilter.bind(this, name)} />
            </th>
        );
    }

    renderSearchSelect(name, options) {
        const { handleChangeFilter } = this.props;
        return (
            <th className="search-th">
                <select type="text" name={name} className="search-input" onChange={handleChangeFilter.bind(this, name)} >
                    {options.map((option, index) => {
                        return (
                            <option key={index} value={option['value']}>{option['label']}</option>
                        );
                    })}
                </select>
            </th>
        );
    }

    render() {
        const { processedElements, totalPages, selectedPage, elementsPerPage } = this.props;
        return (
            <div id="tables-container" className="production-container">
                <div className="table-container table-hover">
                    <table id="titles-table" className="table table-sm table-hover">
                        <thead>
                            <tr>
                                {this.renderTableHeader('ID', 'id', { width: '5%' })}
                                {this.renderTableHeader('Company', 'company', { width: '12%' })}
                                {this.renderTableHeader('Contact', 'name', { width: 'calc(20% - 150px)' })}
                                {this.renderTableHeader('Email', 'email', { width: '13%' })}
                                {this.renderTableHeader('Phone', 'phone', { width: '10%' })}
                                {this.renderTableHeader('Notes', 'notes', { width: '11%' })}
                                {this.renderTableHeader('Active', 'active', { width: '7%' })}
                                {this.renderTableHeader('Last Quote Date', 'last_quote_date', { width: '10%' })}
                                {this.renderTableHeader('Total Quotes', 'total_quotes', { width: '10%' })}
                                <th style={{ width: 80 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {this.renderSearchField('id')}
                                {this.renderSearchField('company')}
                                {this.renderSearchField('name')}
                                {this.renderSearchField('email')}
                                {this.renderSearchField('phone')}
                                {this.renderSearchField('notes')}
                                {this.renderSearchSelect('active', [{ label: '', value: '' }, { label: 'Yes', value: 1 }, { label: 'No', value: 0 }])}
                                {this.renderSearchField('last_quote_date')}
                                {this.renderSearchField('total_quotes')}
                                <th className="search-th"></th>
                            </tr>
                            {this.renderData()}
                        </tbody>
                    </table>
                    <Pagination.Container
                        totalItems={processedElements.length}
                        totalPages={totalPages}
                        selectedPage={selectedPage}
                        elementsPerPage={elementsPerPage}
                    />
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

export default Table;
